<template>
  <footer class="dapp-footer">
    <div>
      <p>DAppChaser，跑在区块链应用落地最前线。</p>
      <p>联系我们：<a href="mailto:contact@dappchaser.com">contact@dappchaser.com</a></p>
      <p>Copyright © 2018 DAppChaser 版权所有</p>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'DAppFooter'
  }
</script>

<style lang="scss" scoped>

  $horizontal-margin: 20px;
  $horizontal-margin-desktop: 40px;

  .dapp-footer {
    background: #3e3e3e;
    padding: $horizontal-margin;
    line-height: 1em;
    color: #AAAAAA;

    a {
      color: #AAAAAA;
    }

    p {
      margin-bottom: 0.5em;
    }

    @media (min-width: 767px) {
      padding: $horizontal-margin-desktop;
    }

    > * {
      margin: auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppFooter.vue